import { assign } from "lodash";
import { IKartgeometri, IKartgeometriSubtyp } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";

export class KartgeometriVirkeskopDrivningspunktRemapper {

    static readonly ovrigDrivningspunkt = "Övrig drivningspunkt";
    static readonly kojplats = "Kojplats";
    static readonly larmpunkt = "Larmpunkt";
    static readonly drivningstext = "Drivningstext";

    static remapFromBackEndModel(kartgeometrier: IKartgeometri[]) {
        kartgeometrier.forEach(this.remapFromBackEndModelSingle);
    }

    static remapFromBackEndModelSingle<T extends IKartgeometriSubtyp>(kartgeometri: T) {
        if (kartgeometri.subtyp2 === KartgeometriVirkeskopDrivningspunktRemapper.ovrigDrivningspunkt) {
            if (kartgeometri.subtyp3 === KartgeometriVirkeskopDrivningspunktRemapper.kojplats) {
                kartgeometri.subtyp2 = KartgeometriVirkeskopDrivningspunktRemapper.kojplats;
                kartgeometri.subtyp3 = null;
            } else if (kartgeometri.subtyp3 === KartgeometriVirkeskopDrivningspunktRemapper.larmpunkt) {
                kartgeometri.subtyp2 = KartgeometriVirkeskopDrivningspunktRemapper.larmpunkt;
                kartgeometri.subtyp3 = null;
            } else if (kartgeometri.subtyp3 === KartgeometriVirkeskopDrivningspunktRemapper.drivningstext) {
                kartgeometri.subtyp2 = KartgeometriVirkeskopDrivningspunktRemapper.drivningstext;
                kartgeometri.subtyp3 = null;
            }
        }
        return kartgeometri;
    }

    static remapToBackEndModelSingle<T extends IKartgeometriSubtyp>(dst: T): T {
        if (dst.subtyp2 === this.kojplats) {
            dst.subtyp2 = this.ovrigDrivningspunkt;
            dst.subtyp3 = this.kojplats;
        } else if (dst.subtyp2 === this.larmpunkt) {
            dst.subtyp2 = this.ovrigDrivningspunkt;
            dst.subtyp3 = this.larmpunkt;
        } else if (dst.subtyp2 === this.drivningstext) {
            dst.subtyp2 = this.ovrigDrivningspunkt;
            dst.subtyp3 = this.drivningstext;
        }
        return dst;
    }

    static remapToBackEndModel(kartgeometrier: IKartgeometri[]): IKartgeometri[] {
        const result: IKartgeometri[] = [];

        if (!Array.isArray(kartgeometrier) || !kartgeometrier.length) {
            return result;
        }

        kartgeometrier.forEach(src => {
            const dst = {} as IKartgeometri;
            assign(dst, src);

            this.remapToBackEndModelSingle(dst);

            result.push(dst);
        });

        return result;
    }
}
